/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Geringfuegigkrankenkassebetriebsnummer2Inputs */



/**

* @param {_Field_Geringfuegigkrankenkassebetriebsnummer2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_geringfuegigkrankenkassebetriebsnummer2 = /** @type {((inputs?: _Field_Geringfuegigkrankenkassebetriebsnummer2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Geringfuegigkrankenkassebetriebsnummer2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Betriebsnr. abweichender Krankenkasse")
});
export { _field_geringfuegigkrankenkassebetriebsnummer2 as "_field_geringfuegigKrankenkasseBetriebsnummer" }